import auth from "../../utils/auth"
import Axios from "axios"
import { errorHandler } from "../../utils"
import qs from 'query-string'
import api from '../../api'
import { subAdapter } from "../organization/adapter"
import { TIMEOUT } from "../../constants"

const { getTokenFromLocalStorage } = auth()

function generateHeaders(){
  const token = getTokenFromLocalStorage()
  return token === null ? {
    'X-Api-Key': api.key
  } : {
    'X-Api-Key': api.key,
    'Authorization': `JWT ${token}`
  }
}

function matchMilestones(milestones){
  let result = []

  if(milestones && milestones.length > 0){
    for (let index = 0; index < milestones.length; index++) {
      const milestone = milestones[index];
      let obj = {}
      if(milestone.id){
        obj = {
          pkMilestoneId: milestone.id,
          tahun: milestone.year,
          deskripsi: [milestone.description_id, milestone.description_en]
        }
      } else {
        obj = {
          tahun: milestone.year,
          deskripsi: [milestone.description_id, milestone.description_en]
        }
      }

      result.push(obj)
    }
  }

  return result
}

function matchOrganization(data){
  return {
    // About
    namaOrganisasi: data.name,
    totalMember: data.total_member,
    deskripsi: [
      data.description_id,
      data.description_en
    ],
    highlight: [
      data.highlight_id,
      data.highlight_en
    ],
    typeApproach: data.approach,
    typeIssues: data.issue,
    typeAudience: data.audience,
    typeOrganisasi: data.type,

    // Contact & Location
    emailOrganisasi: data.email,
    teleponOrganisasi: data.phone,
    lokasi: [
      {
        jalan: data.address,
        pinLocation: data.pin_point
      }
    ],

    // Milestone
    milestoneOrganisasi: matchMilestones(data.milestones)
  }
}

function responseHandler(res){
  if(res.data){
    return res.data
  }

  return res
}

const service = {
  async getData(options) {

    function matchQuery(options){
      let query = {}

      if(options){
        const filtered = {}

        // Filter null value
        const keys = Object.keys(options)
        if(keys.length > 0){
          for (let index = 0; index < keys.length; index++) {
            const key = keys[index];
            if(options[key] === null || options[key] === 'null'){
              console.log(null)
            } else {
              filtered[key] = options[key]
            }
          }
        }

        const {
          approach,
          issue,
          type,
          audience,
          limit,
          offset,
          keyword,
          province
        } = filtered

        if (approach) {
          query.typeApproach = approach;
        }
        if (issue) {
          query.typeIssues = issue;
        }
        if (type) {
          query.typeOrganisasi = type;
        }
        if (audience) {
          query.typeAudience = audience;
        }
        if (limit) {
          query.limit = limit;
        }
        if (offset) {
          query.offset = offset;
        }
        if (keyword) {
          query.title = keyword;
        }
        if (province) {
          query.provinsi = province;
        }
      }

      return query
    }

    const matched = matchQuery(options)
    const stringified = qs.stringify(matched)
    const querystring = `${stringified !== '' ? '?'+stringified : ''}`

    return new Promise(function(resolve, reject){
      // fetch(api.base + api.organizations, {
      //   headers: {
      //     'Content-Type': 'application/x-www-form-urlencoded',
      //     'Authorization': `JWT ${token}`
      //   }
      // })
      //   .then(response => response.json())
      //   .then(data => {
      //     console.log(data)
      //     resolve(data)
      //   })

      Axios.get(`${api.base}${api.organizations}${querystring}`, {
        // timeout: TIMEOUT,
        headers: generateHeaders(),
      }).then(res => {
        console.log(res)
        if(res.data){
          resolve(res.data)
        }
        else{
          resolve(res)
        }
      })

      .catch(err => {
        const message = errorHandler(err)
        reject(message)
      });
    })
  },

  async getDetails({id, lang}) {
    return new Promise(function(resolve, reject){
      if(id){
        Axios.get(`${api.base}${api.organizations}${id}/`, {
          headers: generateHeaders(),
        }).then(res => {
          const response = responseHandler(res)
          resolve(response)
        }).catch(err => {
          const message = errorHandler(err)
          reject(message)
        })
      } else {
        reject('id not provided')
      }
    })
  },

  async updateDetails({id, lang, data}) {
    return new Promise(function(resolve, reject){
      let requestBody = matchOrganization(data)

      Axios.put(`${api.base}${api.organizations_update}${id}/`, requestBody, {
        timeout: TIMEOUT,
        headers: generateHeaders(),
      }).then(res => {
        const response = responseHandler(res)
        resolve(response)
      }).catch(err => {
        const message = errorHandler(err)
        reject(message)
      })
    })
  },

  // Without matching/adapting request body
  async updateDetailsDirect({id, data}) {
    return new Promise(function(resolve, reject){
      let requestBody = data

      Axios.put(`${api.base}${api.organizations_update}${id}/`, requestBody, {
        timeout: TIMEOUT,
        headers: generateHeaders(),
      }).then(res => {
        const response = responseHandler(res)
        resolve(response)
      }).catch(err => {
        const message = errorHandler(err)
        reject(message)
      })
    })
  },

  /**
   * PUT - update organization image
   */
  async updateOrganizationImage(data){
    return new Promise(function(resolve, reject){
      let requestBody = data.formData
      console.log('requestBody', requestBody)

      const config = {
        headers: generateHeaders(),
      }

      if(data.id){
        /* Axios */
        Axios.put(`${api.base}${api.organizations_update}${data.id}/`, requestBody, config)
        .then(res => {
          console.log(res)
          const response = responseHandler(res)
          resolve(response)
        })
        .catch(err => {
          const message = errorHandler(err)
          reject(message)
        });
      } else {
        reject('id not provided.')
      }
    })
  },

  /**
   * PUT - update organization location
   */
  async updateOrganizationLocation({id, data}){
    return new Promise(function(resolve, reject){
      let requestBody = data
      console.log('requestBody', requestBody)

      const config = {
        headers: generateHeaders(),
      }

      if(id){
        /* Axios */
        Axios.put(`${api.base}${api.organization_location}${id}/`, requestBody, config)
        .then(res => {
          console.log(res)
          const response = responseHandler(res)
          resolve(response)
        })
        .catch(err => {
          const message = errorHandler(err)
          reject(message)
        });
      } else {
        reject('id not provided.')
      }
    })
  },

  /**
   * Team Member
   */
  async addMember({id, data}) {
    return new Promise(function(resolve, reject){
      let requestBody = {
        joinInvitation: [
          {
            email: data.email,
            nama: data.name
          }
        ]
      }

      Axios.put(`${api.base}${api.organizations_update}${id}/`, requestBody, {
        timeout: TIMEOUT,
        headers: generateHeaders(),
      }).then(res => {
        const response = responseHandler(res)
        resolve(response)
      }).catch(err => {
        const message = errorHandler(err)
        reject(message)
      })
    })
  },

  async removeMember(id, userId){
    return new Promise(function(resolve, reject){
      let requestBody = {
        removeMember: [
          {
            individu: userId
          }
        ]
      }

      Axios.put(`${api.base}${api.organizations_update}${id}/`, requestBody, {
        timeout: TIMEOUT,
        headers: generateHeaders(),
      }).then(res => {
        const response = responseHandler(res)
        resolve(response)
      }).catch(err => {
        const message = errorHandler(err)
        reject(message)
      })
    })
  },

  async updateJoinRequest(data){
    return new Promise(function(resolve, reject){
      let requestBody = {
        statusRequest: data.status
      }
      console.log('requestBody', requestBody)

      const config = {
        headers: generateHeaders(),
      }

      if(data.id){
        /* Axios */
        Axios.put(`${api.base}${api.join_requests}${data.id}/`, requestBody, config)
        .then(res => {
          console.log(res)
          const response = responseHandler(res)
          resolve(response)
        })
        .catch(err => {
          const message = errorHandler(err)
          reject(message)
        });
      } else {
        reject('id not provided.')
      }
    })
  },

  /**
   * Milestone
   */
  async deleteMilestone(id){
    return new Promise(function(resolve, reject){
      const config = {
        headers: generateHeaders()
      }

      if(id){
        Axios.delete(`${api.base}${api.organization_milestone}${id}/`, config)
        .then(res => {
          console.log(res)
          const response = responseHandler(res)
          resolve(response)
        })
        .catch(err => {
          const message = errorHandler(err)
          reject(message)
        });
      } else {
        reject('id not provided.')
      }
    })
  },

  async updateMilestone({id, data}){
    return new Promise(function(resolve, reject){
      const config = {
        headers: generateHeaders()
      }

      const requestBody = subAdapter.milestone.formToRequestBody(data)

      if(id){
        Axios.put(`${api.base}${api.organization_milestone}${id}/`, requestBody, config)
        .then(res => {
          console.log(res)
          const response = responseHandler(res)
          resolve(response)
        })
        .catch(err => {
          const message = errorHandler(err)
          reject(message)
        });
      } else {
        reject('id not provided.')
      }
    })
  },

  /**
   * Partners
   */
  async addPartnerExternal(id, data){
    // "partnerOrganisasiEksternal": [
    //   {
    //     "pkPartnerEksternalId": "OrgPartEks1308980QBNg",
    //     "namaPartner": "Chooziru Multicellular",
    //     "websitePartner": "https://www.chooziru.com",
    //     "imgLogoPartner": "/assets/image.png"
    //   }
    // ]
    return new Promise(function(resolve, reject){
      let requestBody = {
        partnerOrganisasiEksternal: [
          {
            namaPartner: data.name,
            websitePartner: data.website
          }
        ]
      }

      Axios.put(`${api.base}${api.organizations_update}${id}/`, requestBody, {
        timeout: TIMEOUT,
        headers: generateHeaders(),
      }).then(res => {
        const response = responseHandler(res)
        resolve(response)
      }).catch(err => {
        const message = errorHandler(err)
        reject(message)
      })
    })
  },
  async deletePartner(id){
    return new Promise(function(resolve, reject){
      const config = {
        headers: generateHeaders()
      }

      if(id){
        Axios.delete(`${api.base}${api.organization_partner}${id}/`, config)
        .then(res => {
          console.log(res)
          const response = responseHandler(res)
          resolve(response)
        })
        .catch(err => {
          const message = errorHandler(err)
          reject(message)
        });
      } else {
        reject('id not provided.')
      }
    })
  },

  async updatePartnerExternal(id, requestBody){
    return new Promise(function(resolve, reject){
      const config = {
        headers: generateHeaders()
      }

      if(id){
        Axios.put(`${api.base}${api.organization_partner_external}${id}/`, requestBody, config)
        .then(res => {
          console.log(res)
          const response = responseHandler(res)
          resolve(response)
        })
        .catch(err => {
          const message = errorHandler(err)
          reject(message)
        });
      } else {
        reject('id not provided.')
      }
    })
  },

  async deletePartnerExternal(id){
    return new Promise(function(resolve, reject){
      const config = {
        headers: generateHeaders()
      }

      if(id){
        Axios.delete(`${api.base}${api.organization_partner_external}${id}/`, config)
        .then(res => {
          console.log(res)
          const response = responseHandler(res)
          resolve(response)
        })
        .catch(err => {
          const message = errorHandler(err)
          reject(message)
        });
      } else {
        reject('id not provided.')
      }
    })
  },
}

export default service
